/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_oauth_complete_auth_success_settings = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication successful! Redirecting to settings...`)
};

const zh_hans1_oauth_complete_auth_success_settings = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认证成功！正在跳转至设置页面…`)
};

const zh_hant1_oauth_complete_auth_success_settings = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認證成功！正在跳轉至設定頁面…`)
};

const fr_oauth_complete_auth_success_settings = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification réussie ! Redirection vers les paramètres…`)
};

const de_oauth_complete_auth_success_settings = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentifizierung erfolgreich! Weiterleitung zu den Einstellungen…`)
};

const ja_oauth_complete_auth_success_settings = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認証に成功しました！設定画面にリダイレクトしています…`)
};

const ko_oauth_complete_auth_success_settings = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증 성공! 설정 페이지로 이동 중…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const oauth_complete_auth_success_settings = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.oauth_complete_auth_success_settings(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("oauth_complete_auth_success_settings", locale)
	if (locale === "en") return en_oauth_complete_auth_success_settings(inputs)
	if (locale === "zh-Hans") return zh_hans1_oauth_complete_auth_success_settings(inputs)
	if (locale === "zh-Hant") return zh_hant1_oauth_complete_auth_success_settings(inputs)
	if (locale === "fr") return fr_oauth_complete_auth_success_settings(inputs)
	if (locale === "de") return de_oauth_complete_auth_success_settings(inputs)
	if (locale === "ja") return ja_oauth_complete_auth_success_settings(inputs)
	return ko_oauth_complete_auth_success_settings(inputs)
};